export const LICENSE_VALIDATION_ERROR_STATUS = 461;
